<template>
    <div class="form-error" v-if="hasErrors" role="alert">
        <ul>
            <li v-for="msg in errorMessages" v-html="msg" tabindex="0" :aria-label="msg" role="alert"></li>
        </ul>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';

    @Component({
        name: 'FormError',
    })
    export default class FormError extends Vue
    {
        @Prop({
            required: false,
            type: [String, Array],
        }) name: string | string[];

        @Prop({
            required: false,
            type: [String, Array],
        }) messages: string | string[];

        get hasErrors()
        {
            let messages = this.errorMessages;
            if (Array.isArray(messages) && messages.length)
            {
                return true;
            }
            else if ('string' === typeof messages && '' !== messages)
            {
                return true;
            }
            else if ('object' === typeof messages && messages)
            {
                for (let key in messages)
                {
                    if (messages.hasOwnProperty(key))
                    {
                        return true;
                    }
                }
            }

            return false;
        }

        get errorMessages()
        {
            if (this.messages)
            {
                return Array.isArray(this.messages) ? this.messages : [this.messages];
            }
            if (this.name && Array.isArray(this.name))
            {
                let errors: string[] = [];
                for (let name of this.name)
                {
                    let fieldErrors = this.$store.state.form.errors[name];
                    if (Array.isArray(fieldErrors))
                    {
                        errors.push(...fieldErrors);
                    }
                    else if (fieldErrors && typeof fieldErrors === 'object')
                    {
                        errors.push(...Object.values(fieldErrors) as string[]);
                    }
                }

                return errors;
            }

            return this.$store.state.form.errors[this.name];
        }
    }
</script>